// NSWParks booking strategy.
//
// URL shape:
//   ${site.reserveUrl}&open_date=YYYY-MM-DDT00:00:00&days=<stay>&oids=1,2,3&oa=<capacity>,0,0

import { format } from "date-fns";
import { resolveMinStayLength, resolveMinCapacity } from "./_context.js";

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    const stay = resolveMinStayLength(ctx);
    const capacity = resolveMinCapacity(ctx);
    return `${site.reserveUrl}&open_date=${format(arrivalDate, "yyyy-MM-dd")}T00:00:00&days=${stay}&oids=1,2,3&oa=${capacity},0,0`;
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &open_date=YYYY-MM-DDT00:00:00.",
        },
        departureDate: {
          status: "required",
          notes: "Used to derive &days=<nights>.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already identifies the site.",
        },
        partySize: {
          status: "optional",
          defaultValue: 1,
          notes: "Encoded as &oa=<partySize>,0,0; defaults to 1 when omitted.",
        },
      },
    };
  },
};
